import { ProductCategory } from "..";

export interface ProductCategoryDomain<TProductCategory extends ProductCategory> {
  Detail: TProductCategory;
  DomainId: string; 
  ChildProductCategoryIds: string[];
  ParentCategory: string;
  ProductCategoryName?: string;
}
